'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import Card from './Card'
import { ValuePropositionCardModel } from './Card/types'

const SLIDER_ITEM_COUNT = 3

const generateSlidersContent = (): Array<ValuePropositionCardModel> =>
  Array.from({ length: SLIDER_ITEM_COUNT }, (_, index) => index + 1).map(contentItemOrder => ({
    imageFileName: `illustration-${contentItemOrder}`,
    title: `card_${contentItemOrder}.title`,
    description: `card_${contentItemOrder}.description`,
    action: `card_${contentItemOrder}.action`,
    testId: `pro-integrations-value-proposition-item${contentItemOrder}`,
  }))

const ValuePropositionSection = () => {
  const translate = useTranslate('business.pro_integrations.value_proposition')
  const sliderCardObjects = generateSlidersContent()

  return (
    <>
      <section
        className="pro-integrations__value-proposition"
        data-testid="pro-integrations-value-proposition"
      >
        <h2
          className="pro-integrations__value-proposition-title"
          data-testid="pro-integrations-value-proposition-title"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: translate('title') }}
        />
      </section>
      <div className="pro-integrations__value-proposition-content">
        {sliderCardObjects.map((card, index) => (
          <Card key={index} {...card} />
        ))}
      </div>
    </>
  )
}

export default ValuePropositionSection
